import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./registration.css";
import { useNavigate } from "react-router-dom";
import DataSevices from "../Services/DataSevices";
import { LOGOUT } from "../constants/Constants";
import { useAuth } from "./../context/AuthContext";


const AddParticipant = () => {
  const [formData, setFormData] = useState({
    id : null,
    role : null,
    name: "",
    email: sessionStorage.getItem("userEmail") || "",
    dbId: "",
    facGroup: "",
    facilitatorId: "",
    whatsApp: "",
    committedRounds: "",
    dob:""
  });

   const { login, logout } = useAuth();

  const [facilitators, setFacilitators] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fetch facilitators
  useEffect(() => {
    DataSevices.getFacilitatorList()
          .then((res) => {
            setFacilitators(res.data);

          })
          .catch((err) => {
            console.log(err);
          });
  }, []);

  useEffect(() => {
    DataSevices.getParticipantsInfo(sessionStorage.getItem("userEmail"))
                .then((res) => {
                     if (res.data && res.data.whatsApp) {
                            navigate("/dashboard") }
                     else if (res.data.whatsApp === null) {
                            setFormData((prev) => ({
                              ...prev,
                              name: res.data.name || "",
                              email: res.data.email || "",
                              dbId: res.data.dbId || "",
                              facGroup: res.data.facGroup || "",
                              facilitatorId: res.data.facId || "",
                              id: res.data.id || "",
                              role: res.data.role || ""
                            }));
                     }

                  })
                  .catch((err) => {
                    console.log(err);
                  });
  }, []);

  const  handleCancel = async () => {
    sessionStorage.clear();
     logout()
    await fetch(LOGOUT, {
                method: "POST",
                credentials: "include",
              }).then(() => {
                navigate("/");
              })
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      id: formData.id != null ? formData.id : null,
      email: formData.email,
      name: formData.name,
      dbId: formData.dbId || null,
      facGroup: formData.facGroup,
      facId: Number(formData.facilitatorId),
      whatsApp: formData.whatsApp || null,
      dob: formData.dob || null,
      committedRounds : formData.committedRounds || 0,
      role : formData.role != null ? formData.role : null
    };

    try {
      setLoading(true);
      DataSevices.saveParticipants(payload)
        .then((res) => {
            navigate("/dashboard");
        })
        .catch((err) => {
          console.log(err);
        });

    } catch (err) {
      console.error(err);
      alert("Error submitting form");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid form-bg d-flex justify-content-center align-items-center">
      <div className="card form-card shadow-lg">
        <div className="card-body">
          <h4 className="text-center mb-4">Add Participant</h4>

          <form onSubmit={handleSubmit}>
            {/* Name */}
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Name*"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            {/* Email */}
            <div className="mb-3">
              <input
                type="email"
                className="form-control"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                disabled
              />
            </div>

            {/* WhatsApp */}
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="WhatsApp*"
                name="whatsApp"
                value={formData.whatsApp}
                onChange={handleChange}
                required
              />
            </div>

            {/* Date of Birth */}
            <div className="mb-3">
              <input
                type="date"
                className="form-control"
                placeholder="Date of Birth*"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                required
              />
            </div>

            {/* Committed Rounds */}
            <div className="mb-3">
              <input
                type="number"
                className="form-control"
                placeholder="Committed Rounds*"
                name="committedRounds"
                value={formData.committedRounds}
                onChange={handleChange}
                required
              />
            </div>

            {/* DB ID */}
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="DB Id (e.g HLZ..) (optional)"
                name="dbId"
                value={formData.dbId}
                onChange={handleChange}

              />
            </div>

            {/* Facilitator Dropdown */}
            <div className="mb-3">
              <select
                className="form-select"
                name="facilitatorId"
                value={formData.facilitatorId}
                onChange={handleChange}
                required
              >
                <option value="">Select Facilitator</option>
                {facilitators.map((f) => (
                  <option key={f.id} value={f.id}>
                    {f.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Group Dropdown */}
            <div className="mb-3">
              <select
                className="form-select"
                name="facGroup"
                value={formData.facGroup}
                onChange={handleChange}
                required
              >
              <option value="">Select Group</option>
                <option value="ALUMNI">ALUMNI</option>
                <option value="GAURANGI">GAURANGI</option>
                <option value="YASHODA">YASHODA</option>
                <option value="NANDBABA">NANDBABA</option>
                <option value="PRAHLAD">PRAHLAD</option>
              </select>
            </div>

            {/* Buttons */}
            <div className="d-flex gap-2">
              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>

              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddParticipant;